/**CORE LIBRARIES IMPORT */
import React from "react";


const TermsConditions=()=>{
    return(
        <>
           
        </>
    )
}

export default TermsConditions;